<template>
  <div class="display-box" >
    <div class="module-layout">
      <!-- <el-select v-model="span" size="mini" style="width:60px;margin:0 10px" @change="changeLayout">
        <el-option value="1">1</el-option>
        <el-option value="2">2</el-option>
        <el-option value="3">3</el-option>
      </el-select>
      <div>行</div> -->
      <el-select v-model="col" size="mini" style="width:60px;margin:0 10px" @change="changeLayout">
        <el-option :value="1">1</el-option>
        <el-option :value="2">2</el-option>
        <el-option :value="3">3</el-option>
        <el-option :value="4">4</el-option>
        <!-- <el-option value="5">5</el-option> -->
        <!-- <el-option value="6">6</el-option> -->
      </el-select>
      <div>列</div>
      <div style="marginLeft:20px">排版</div>
    </div>
    <div class="pl5 pr5 pt5 pb5" style="background-color: #fff">
      <div style="background-color: #F2F3F6" >
        <p class="w100 font-28 tx-c">专题事项</p>
        <div class="list-box">
          <div >
            <draggable
              :group="{ name: 'module', put: true }"
              @add="addModuleItem"
              @update="sortModuleItem"
              :value="subjectData.data"
              animation="300"
              class="topic-draggable"
              :ghostClass="`topic-items-ghost-${col}`"
            >
              <div :style="`width: ${handleWidth(col || 4)}`" v-for="(e, i) in subjectData.data" :key="e.topicId" class="col-container pl10 pr10">
                <div class="tx-c bg-w pic-box mb20">
                  <img :src="e.topicFileUrl" alt="" width="100%" height="106px">
                  <p class="font-16 lh30 ellipsis">{{e.topicName}}</p>
                  <div class="font-12 grey flex-box serve-list">
                    <template v-for="(ee, ii) in e.serveList">
                      <div class="serve-item mb-auto" >
                        {{ee.serveName}}
                      </div>
                      <span class="mb-auto" v-if="ii<e.serveList.length-1">&nbsp;|&nbsp;</span>
                    </template>
                  </div>
                  <i class="el-icon-error" @click="removeModules(e, i)"></i>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "topic",
  components: { draggable },
  props: ['childModules'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      subjectData: {},
      span: 1,
      col: 4,
      changed: false,
    };
  },
  created(){
    let subject = this.moduleList.find((item) => {
      return item.cardType === 'TOPIC'
    })
    if(subject){
      this.subjectData = JSON.parse(JSON.stringify(subject.cardModules[0]));
      this.col = subject.cardModules[0].col;
    }
  },
  computed: {
    ...mapGetters(['moduleList']),
  },
  methods: {
    changeLayout(){
      // if(this.col * this.span < this.subjectData.data.length){
      //   this.subjectData.data.length = this.col * this.span
      // }
      this.$emit('caseChanged', true)
    },
    handleWidth(col){
      switch (col) {
        case 1:
          return '100%'
        case 2:
          return '50%'
        case 3:
          return '33.3%'
        case 4:
          return '25%'
        case 5:
          return '20%'
        case 6:
          return '16.6%'
        default:
          return '50%'
      }
    },
    addModuleItem(e){
      // // 判断是否超出个数限制
      // const limit = this.span * this.col;
      // if(this.subjectData.data.length >= limit){
      //   this.$message.warning('超出设置的行数,若要继续添加请修改行列数')
      //   return
      // }
      let targetIndex = e.newIndex;
      let childModulesIndex = e.oldIndex;
      let childModule = this.childModules[childModulesIndex];
      // 判断添加的模块是否存在
      let exist;
      if(this.subjectData.data){
        exist = this.subjectData.data.some((item) => {
          return item.topicId === childModule.topicId;
        })
      }else {
        this.subjectData.data = []
        exist = false
      }
      if(exist){
        this.$message.warning('不能重复添加已添加的模块')
        return
      }
      this.subjectData.data.splice(targetIndex, 0, childModule);

      this.$emit('caseChanged', true)
    },
    sortModuleItem(e){
      let newIndex = e.newIndex;
      let oldIndex = e.oldIndex;

      let moduleItem = this.subjectData.data[oldIndex];
      this.subjectData.data.splice(oldIndex, 1);
      this.subjectData.data.splice(newIndex, 0, moduleItem);

      this.$emit('caseChanged', true)
    },
    removeModules(item, index){
      this.subjectData.data.splice(index, 1)

      this.$emit('caseChanged', true)
    },
    isEmpty(){
      return this.subjectData.data.length ? false : true
    },
  },
  watch: {
    'subjectData.data'(val){
      this.$emit('selectedChange', {data:val, module: 'topic', col: this.col})
    },
    col(val){
      this.$emit('selectedChange', {data:this.subjectData.data, module: 'topic', col: this.col})
    }
  },
  filters: {}
}
</script>

<style lang="less" >
.display-box {
  
}
.list-box {
  padding: 40px 0 20px;
}
.item-box:hover,
.pic-box:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.col-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pic-box {
  width: 210px;
  height: 200px;
  cursor: move;
  position: relative;
  &:hover .el-icon-error {
    display: block !important;
  }
}
.lh30 {
  line-height: 28px;
}
.serve-list {
  height: 64px;
  flex-wrap: wrap;
  justify-content: center;
}
.serve-item {
  user-select: none;
}
.mb-auto{
  margin-bottom: auto;
  line-height: 1;
}
.module-layout {
  padding-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.topic-draggable {
  background-color: transparent;
  min-height: 200px;
  padding: 0 10px;
  display: flex;
  flex-wrap: wrap;
  .topic-items-ghost-1 {
    width: 100%;
  }
  .topic-items-ghost-2 {
    width: 50%;
  }
  .topic-items-ghost-3 {
    width: 33.3%;
  }
  .topic-items-ghost-4 {
    width: 25%;
  }
}
</style>